<template>
  <v-card pl-4>
    <v-layout column v-if="loading">
      <v-flex class="text-md-center py-3">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-flex>
    </v-layout>

    <template v-else>
      <v-layout pt-2 px-4>
        <v-flex xs6>
          <v-layout>
            <v-list>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title><b>{{user.name}}</b> <i>({{user.id}})</i></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Contact Phone</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{user.contactPhone}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Brief Bio</v-list-tile-title>
                  <v-list-tile-sub-title>{{user.briefBio}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="user.driverProfile">
                <v-list-tile-content>
                  <v-list-tile-title>CDL Expires:</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{user.driverProfile.cdlExpires | formatDate}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="user.driverProfile">
                <v-list-tile-content>
                  <v-list-tile-title>Medical Expires:</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{user.driverProfile.medicalExpires | formatDate}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-layout>
            <v-layout column class="mt-3">
              <v-layout>
                <v-flex sm2 class="secondary--text">Company</v-flex>
                <v-flex sm2 class="secondary--text">Phone</v-flex>
                <v-flex sm2 class="secondary--text">Email</v-flex>
                <v-flex sm3 class="secondary--text">Permissions</v-flex>
              </v-layout>
              <v-divider class="my-1" />
              <template v-for="(companyAccount, index) in user.companyAccounts">
                <v-layout :key="index">
                  <v-flex sm2>
                    {{companyAccount.companyDisplayName}}</v-flex>
                  <v-flex sm3>{{companyAccount.contactPhone}} </v-flex>
                  <v-flex sm3>{{companyAccount.contactEmail}} </v-flex>
                  <v-flex sm3>
                    {{companyAccount.companyPermissions ?
                    companyAccount.companyPermissions.join(', ') : null}}
                  </v-flex>
                </v-layout>
                <v-divider class="my-1" :key="'div_'+index" />
              </template>

            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
      <notification-settings expandVersion :user-id="user.id"></notification-settings>
    </template>
  </v-card>
</template>

<script>
import API from '@/api';
import NotificationSettings from '@/pages/User/NotificationSettings';

export default {
  name: 'UserExpand',
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  components: {
    NotificationSettings,
  },
  data() {
    return {
      loading: false,
      user: null,
    };
  },
  methods: {
    async loadUser() {
      this.loading = true;
      const apiResponse = await API.user.getUserProfile({ userId: this.userId });
      this.user = apiResponse.data;
      this.loading = false;
    },
  },
  created() {
    this.loadUser();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserExpand.vue